import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class FirmaRevisionService {
  public myurl = url + "firma_revision/";


  constructor(private http:HttpClient) {
    
   }
  
 
  updateFirma( firma: any ) {
    let headers = new HttpHeaders();
    let body = JSON.stringify(firma);
    headers.append('Content-Type' , 'application/json');
   
    return this.http.put(this.myurl + "firma_revision.php",body, { headers:headers } ).pipe(map( resp => {
      return resp;
    } ) );
  }

  
  
}
